export const formatBenefitCode = (code: number | null) =>
  code == null ? '' : `P${code.toString().padStart(4, '0')}`;

export const formatCircuitCode = (code: number | null) =>
  code == null ? '' : `C${code.toString().padStart(4, '0')}`;
